export const GET_USER = () => ({ url: `/user/me` });

export const GET_MATRIX_PROFILES = (depotCode, dailyOnly) => ({
  url: `/depots/${depotCode}/matrix/templates?dailyOnly=${!!dailyOnly}`,
});

export const GET_MATRIX_TEMPLATE = (
  depotCode,
  templateId,
  type,
  saebiVersion
) => ({
  url: `/depots/${depotCode}/matrix/template/${templateId}/type/${type}/saebiVersion/${saebiVersion}`,
});

export const GET_DEPOT_POSTCODES = (depotCode) => ({
  url: `/depots/${depotCode}/matrix/postcodes`,
});

export const IS_POSTCODE_IN_USE = (depotCode, postcode, postcodesInSector) => ({
  url: `/depots/${depotCode}/matrix/postcodeInUse/${postcode}/${postcodesInSector}`,
});

export const GET_MATRIX_DAY = (depotCode, dayOfWeek, templateId) => ({
  url: `/depots/${depotCode}/day/${dayOfWeek}/matrix/${templateId}/get`,
});

export const UPDATE_MATRIX_DAY = (depotCode, dayOfWeek, templateId) => ({
  url: `/depots/${depotCode}/day/${dayOfWeek}/matrix/${templateId}/update`,
});

export const CREATE_BLANK_TEMPLATE = (depotCode) => ({
  url: `/depots/${depotCode}/matrix/createBlankTemplate`,
});

export const CREATE_FROM_TEMPLATE = (depotCode) => ({
  url: `/depots/${depotCode}/matrix/createFromTemplate`,
});

export const UPDATE_MATRIX_TEMPLATE_NAME = (depotCode, templateId) => ({
  url: `/depots/${depotCode}/matrix/template/${templateId}/rename`,
});

export const DELETE_MATRIX_TEMPLATE = (depotCode, templateId) => ({
  url: `/depots/${depotCode}/matrix/template/${templateId}/delete`,
});

export const COPY_TO_DAILY_PLAN = (depotCode) => ({
  url: `/depots/${depotCode}/matrix/copyToDailyMatrix`,
});

export const GET_VOLUME_DATA = (
  depotCode,
  overlayId,
  overlayPercentage = 0
) => ({
  url: `/depots/${depotCode}/matrix/volume/${overlayId}?overlayPercentage=${overlayPercentage}`,
});

export const GET_DEPOT_CONFIG = (depotCode) => ({
  url: `/depots/${depotCode}/config`,
});

export const GET_LOOK_UP_TABLES = (depotCode, saebiVersion) => ({
  url: `/depots/${depotCode}/depotMapTiles/saebiVersion/${saebiVersion}`,
});

export const SAVE_LOOK_UP_TABLES = (depotCode) => ({
  url: `/depots/${depotCode}/depotMapTiles/saveArtificialTiles`,
});

export const LOCK_DEPOT = (depotCode) => ({ url: `/depots/${depotCode}/lock` });

export const UNLOCK_DEPOT = (depotCode) => ({
  url: `/depots/${depotCode}/unlock`,
});

export const LOCK_ROUTE_DAY = (depotCode, dayOfWeek, routeCode) => ({
  url: `/depots/${depotCode}/day/${dayOfWeek}/route/${routeCode}/lock`,
});

export const UNLOCK_ROUTE_DAY = (depotCode, dayOfWeek, routeCode) => ({
  url: `/depots/${depotCode}/day/${dayOfWeek}/route/${routeCode}/unlock`,
});

export const GET_SCHEDULED_COLLECTIONS = (depotCode, date) => ({
  url: `/depots/${depotCode}/scheduledCollections?date=${date}`,
});

export const ROUTE_SCHEDULE = (depotCode, routeId) => ({
  url: `/depots/${depotCode}/schedule/${routeId}`,
});

export const GET_VOLUME_OVERLAYS = (depotCode) => ({
  url: `/depots/${depotCode}/matrix/volume/getavailableoverlays`,
});

export const POST_LOCK_TEMPLATE = (depotCode, templateId) => ({
  url: `/depots/${depotCode}/matrix/template/${templateId}/lock`,
});

export const POST_UNLOCK_TEMPLATE = (depotCode, templateId) => ({
  url: `/depots/${depotCode}/matrix/template/${templateId}/unlock`,
});

export const GET_DAY_SECTIONS = (depotCode, dayOfWeek) => ({
  url: `/depots/${depotCode}/day/${dayOfWeek}/section/get`,
});

export const GET_WEEK_SECTIONS = (depotCode) => ({
  url: `/depots/${depotCode}/week/section/get`,
});

export const SAVE_MATRIX_TEMPLATE = (
  depotCode,
  templateId,
  type,
  saebiVersion
) => ({
  url: `/depots/${depotCode}/matrix/template/${templateId}/type/${type}/saebiVersion/${saebiVersion}`,
});

export const GET_SIMULATION_PERCENTAGES = (depotCode, overlayId) => ({
  url: `/depots/${depotCode}/matrix/volume/simulation/${overlayId}`,
});

export const GET_ROBOT_SUPPLIERS = (depotCode) => ({
  url: `/depots/${depotCode}/robotSuppliers`,
});

export const GET_VEHILCES = () => ({ url: `/reference/vehicleType` });

export const GET_PICKUP_PARTNERS = () => ({ url: `/reference/pickupPartners` });

export const GET_COUNTRIES = () => ({ url: `/reference/countries` });

export const GET_DRIVER_PREFIX = () => ({ url: `/reference/driverPrefix` });

export const GET_DRIVER_PROFILE_IMAGE = (photoCode) => ({
  url: `/drivers/photo/${photoCode}`,
});

export const VALIDATE_DRIVER_PROFILE_IMAGE = () => ({
  url: `/drivers/photo/validate`,
});

export const LOCK_DRIVER_PROFILE = (driverCode) => ({
  url: `/drivers/${driverCode}/lock/profile`,
});

export const UNLOCK_DRIVER_PROFILE = (driverCode) => ({
  url: `/drivers/${driverCode}/unlock/profile`,
});

export const UPDATE_DRIVER_PROFILE = (driverCode) => ({
  url: `/drivers/${driverCode}/update/profile`,
});

export const LOCK_DRIVER_DAY = (driverCode, dayOfWeek) => ({
  url: `/depots/${
    driverCode.split("*")[0]
  }/day/${dayOfWeek}/driver/${driverCode}/lock`,
});

export const UNLOCK_DRIVER_DAY = (driverCode, dayOfWeek) => ({
  url: `/depots/${
    driverCode.split("*")[0]
  }/day/${dayOfWeek}/driver/${driverCode}/unlock`,
});

export const FORCE_UNLOCK_DEPOT_DRIVERS = (depotCode) => ({
  url: `/drivers/${depotCode}/forceUnlockAll`,
});

export const FORCE_UNLOCK_DEPOT_DRIVERS_DAY = (depotCode, dayOfWeek) => ({
  url: `/drivers/${depotCode}/forceUnlockAll/${dayOfWeek}`,
});

// DRIVER MANAGEMENT
export const SEARCH_ADDRESSES_BY_PHRASE = (phrase) => ({
  url: `/addresses/search/${phrase}`,
});

export const ADD_DRIVER_PROFILE = (driverCode) => ({
  url: `/drivers/${driverCode}/add/profile`,
});

export const REMOVE_DRIVER_PROFILE = (driverCode) => ({
  url: `/drivers/${driverCode}/remove/profile`,
});

export const GET_NON_DRIVER_USERS = (depotCode) => ({
  url: `/users/${depotCode}/getNonDrivers`,
});

export const FORCE_UNLOCK_MATRIX_WEEK = (depotCode) => ({
  url: `/depots/${depotCode}/week/matrix/forceUnlock`,
});

export const GET_MATRIX_WEEK = (depotCode) => ({
  url: `/depots/${depotCode}/week/matrix/get`,
});

export const UPDATE_MATRIX_WEEK = (depotCode) => ({
  url: `/depots/${depotCode}/week/matrix/update`,
});

export const GET_MATRIX_DAY_LOCKS = (
  depotCode,
  dayOfWeek,
  sessionChecksum
) => ({
  url: `/depots/${depotCode}/day/${dayOfWeek}/matrix/getLocks/${sessionChecksum}`,
});

export const GET_MATRIX_WEEK_LOCKS = (depotCode, sessionChecksum) => ({
  url: `/depots/${depotCode}/week/matrix/getLocks/${sessionChecksum}`,
});

// ROUTES MANAGEMENT
export const GET_DEPOT_ROUTES = (depotCode) => ({
  url: `/depots/${depotCode}/routes/get`,
  service: "routes",
});

export const ADD_DEPOT_ROUTE = (depotCode) => ({
  url: `/depots/${depotCode}/routes/add`,
  service: "routes",
});

export const UPDATE_DEPOT_ROUTE = (depotCode) => ({
  url: `/depots/${depotCode}/routes/update`,
  service: "routes",
});

export const REMOVE_DEPOT_ROUTE = (depotCode, routeCode) => ({
  url: `/depots/${depotCode}/routes/remove/${routeCode}`,
  service: "routes",
});

// SECTIONS MANAGEMENT
export const GET_SECTION_MANAGEMENT_SECTIONS_WEEK = (depotCode) => ({
  url: `/depots/${depotCode}/sections/week`,
  service: "sections",
});

export const ADD_SECTION = (depotCode) => ({
  url: `/depots/${depotCode}/sections/add`,
  service: "sections",
});

export const UPDATE_SECTION = (depotCode) => ({
  url: `/depots/${depotCode}/sections/update`,
  service: "sections",
});

export const REMOVE_SECTION = (depotCode) => ({
  url: `/depots/${depotCode}/sections/remove`,
  service: "sections",
});

// SHIFT MANAGERS MANAGEMENT
export const GET_DEPOT_SHIFT_MANAGERS_SECTIONS = (depotCode) => ({
  url: `/depots/${depotCode}/sections/get`,
  service: "shiftManagers",
});

export const GET_DEPOT_SHIFT_MANAGERS = (depotCode) => ({
  url: `/depots/${depotCode}/shiftManagers/get`,
  service: "shiftManagers",
});

export const UPDATE_DEPOT_SHIFT_MANAGER = (depotCode) => ({
  url: `/depots/${depotCode}/shiftManagers/update`,
  service: "shiftManagers",
});
